import { render } from "./Offers.vue.ts?vue&type=template&id=69f8d1fa&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Offers.vue?vue&type=template&id=69f8d1fa&scoped=true&ts=true"
import script from "./Offers.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Offers.vue?vue&type=script&setup=true&lang=ts"
export * from "./Offers.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Offers.vue?vue&type=script&setup=true&lang=ts"

import "./Offers.vue.scss?vue&type=style&index=0&id=69f8d1fa&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Offers.vue?vue&type=style&index=0&id=69f8d1fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f8d1fa"],['__file',"src/apps/merchant3/components/offers/Offers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69f8d1fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69f8d1fa', __exports__)) {
    api.reload('69f8d1fa', __exports__)
  }
  
  module.hot.accept("./Offers.vue.ts?vue&type=template&id=69f8d1fa&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Offers.vue?vue&type=template&id=69f8d1fa&scoped=true&ts=true", () => {
    api.rerender('69f8d1fa', render)
  })

}


export default __exports__